function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-fill-purple",
  d: "M18.95,5.95h-2.71V5.02c0-1.66-1.35-3.01-3.01-3.01h-2.46c-1.66,0-3.01,1.35-3.01,3.01v0.93H5.05 c-1.66,0-3.01,1.35-3.01,3.01v1.7v2v6.24c0,1.66,1.35,3.01,3.01,3.01h13.91c1.66,0,3.01-1.35,3.01-3.01v-6.24v-2v-1.7 C21.97,7.3,20.62,5.95,18.95,5.95z M9.76,5.02c0-0.56,0.45-1.01,1.01-1.01h2.46c0.56,0,1.01,0.45,1.01,1.01v0.93H9.76V5.02z  M19.97,18.9c0,0.56-0.45,1.01-1.01,1.01H5.05c-0.56,0-1.01-0.45-1.01-1.01v-6.24H11v2.73h2v-2.73h6.97V18.9z M13,10.66V9.31h-2 v1.35H4.03v-1.7c0-0.56,0.45-1.01,1.01-1.01h2.71h8.48h2.71c0.56,0,1.01,0.45,1.01,1.01v1.7H13z"
}));

var SvgIconEquipment = function SvgIconEquipment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEquipment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_equipment.e569929a.svg";
export { ForwardRef as ReactComponent };